import React from 'react';
import styles from './index.module.scss';
import Link from "../../CustomLink";

import logo from '../../../assets/icons/logo/footer_logo.webp';
// import facebook from '../../../assets/icons/socials/facebook.svg';
// import linkedIn from '../../../assets/icons/socials/linkedIn.svg';
// import twitter from '../../../assets/icons/socials/twitter.svg';
// import instagram from '../../../assets/icons/socials/instagram.svg';
// import youtube from '../../../assets/icons/socials/youtube.svg';

const Footer = () => {
    return (
        <footer className={styles.root}>
            <div className={styles.wrapper}>
                <div className={styles.container}>
                  <Link to='/'>
                    <img src={logo} alt="AutoEasy logo" className={styles.logo} loading={'lazy'} />
                  </Link>
                  {/*<div className={styles.content}>*/}
                  {/*  <p className={styles.dot}>.</p>*/}

                  {/*  <div className={styles.linksList}>*/}
                  {/*    <Link to='/'>*/}
                  {/*      <p className={styles.subtitle}>Inventory</p>*/}
                  {/*    </Link>*/}
                  {/*    <Link to='/'>*/}
                  {/*      <p className={styles.subtitle}>Reviews</p>*/}
                  {/*    </Link>*/}
                  {/*    <Link to='/'>*/}
                  {/*      <p className={styles.subtitle}>Buyer’s guide</p>*/}
                  {/*    </Link>*/}
                  {/*  </div>*/}
                  {/*  <p className={styles.dot}>.</p>*/}
                  {/*  <div className={styles.socials}>*/}
                  {/*    <p className={styles.subtitle}>Follow us</p>*/}
                  {/*    <div className={styles.socials__list}>*/}
                  {/*      <img className={styles.socials__icon} src={facebook} alt="facebook"/>*/}
                  {/*      <img className={styles.socials__icon} src={linkedIn} alt="linkedIn"/>*/}
                  {/*      <img className={styles.socials__icon} src={twitter} alt="twitter"/>*/}
                  {/*      <img className={styles.socials__icon} src={youtube} alt="youtube"/>*/}
                  {/*      <img className={styles.socials__icon} src={instagram} alt="instagram"/>*/}
                  {/*    </div>*/}
                  {/*  </div>*/}
                  {/*</div>*/}
                </div>
              <div className={styles.footer}>
                <p className={styles.text}>© 2023 AutoEasy. All rights reserved. |</p>

                <div className={styles.flex}>
                  <Link to='/privacy_policy'>
                    <p className={styles.link}>Privacy</p>
                  </Link>
                  <Link to='/terms_of_service'>
                    <p className={styles.link}>Terms of Service</p>
                  </Link>
                  <Link to='/disclaimer'>
                    <p className={styles.link}>Disclaimer</p>
                  </Link>
                </div>
              </div>
            </div>
        </footer>
    )
}

export default React.memo(Footer)
